// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

export const ignoreUTCPlugin = (option, Dayjs, _dayjs) => {
  const oldParse = Dayjs.prototype.parse;

  Dayjs.prototype.parse = function (cfg) {
    if (typeof cfg.date === "string") {
      cfg.date = cfg.date.replace(/Z$/, "");
    }
    oldParse.call(this, cfg);
  };
};
